import { Popover } from "@base-ui-components/react";

export namespace PopoverPositioner {
	export type ElementName = "Popover.Positioner";
	export type ElementType = HTMLElement;
	export type Props = Popover.Positioner.Props;
}

export const PopoverPositioner = (componentProps: PopoverPositioner.Props) => {
	const { children, ...restProps } = componentProps;

	return <Popover.Positioner {...restProps}>{children}</Popover.Positioner>;
};
